<dx-toolbar id="fieldCropToolbar" class="field-editor-map-toolbar">
  <dxi-item location="before" locateInMenu="never">
    <div *dxTemplate>
      <div class="flex flex-row items-center">
        <span
          class="block color mx-2"
          [ngStyle]="{ backgroundColor: fieldCrop?.color }"
        ></span>
        <span class="block mr-2 text-sm font-light px-2"
          >{{ fieldCrop?.name }}
        </span>
      </div>
    </div>
  </dxi-item>

  <dxi-item location="before" locateInMenu="never">
    <div *dxTemplate>
      <div
        class="flex flex-row items-center bg-gray-200 px-2 py-1 mx-2 rounded"
      >
        <ic-icon [icon]="areaIcon" height="18px" width="18px"></ic-icon>
        <span class="font-bold px-1"
          >{{ fieldCrop?.polygonAreaToHaUnit() }} ({{ areaPercent() }} %)</span
        >
      </div>
    </div>
  </dxi-item>

  <dxi-item location="after" locateInMenu="never">
    <div *dxTemplate>
      <span
        style="height: 30px"
        class="block mx-1 border-l border-solid border-gray-400"
      ></span>
    </div>
  </dxi-item>

  <dxi-item
    widget="dxButton"
    location="after"
    locateInMenu="never"
    [options]="editButtonOptions"
  >
  </dxi-item>

  <dxi-item
    widget="dxButton"
    location="after"
    locateInMenu="never"
    [options]="drawButtonOptions"
  >
  </dxi-item>

  <dxi-item *ngIf="hasChanges()" location="after" locateInMenu="never">
    <div *dxTemplate>
      <div class="relative">
        <dx-button
          icon="revert"
          text="annuler"
          (onClick)="cancelEdit()"
          stylingMode="text"
        >
        </dx-button>
        <span class="button-badge"></span>
      </div>
    </div>
  </dxi-item>

  <dxi-item *ngIf="hasChanges()" location="after" locateInMenu="never">
    <div *dxTemplate>
      <div class="relative">
        <dx-button
          icon="save"
          text="Sauvegarder"
          (onClick)="saveChanges()"
          stylingMode="text"
        >
        </dx-button>
        <span class="button-badge"></span>
      </div>
    </div>
  </dxi-item>

  <dxi-item *ngIf="loadingVisible" location="after" locateInMenu="never">
    <div *dxTemplate>
      <dx-load-indicator
        style="margin: 4px"
        height="20"
        width="20"
      ></dx-load-indicator>
    </div>
  </dxi-item>

  <dxi-item location="after" locateInMenu="never">
    <div *dxTemplate>
      <span
        style="height: 30px"
        class="block border-l border-solid border-gray-400"
      ></span>
    </div>
  </dxi-item>

  <dxi-item
    widget="dxButton"
    location="after"
    locateInMenu="never"
    [options]="closeButtonOptions"
  >
  </dxi-item>
</dx-toolbar>

<dx-popover
  class="field-editor-changes-popover"
  target="#fieldCropToolbar"
  [deferRendering]="false"
  [showTitle]="true"
  [(visible)]="formVisible"
  (onHiding)="formOnHiding()"
  [elementAttr]="{ class: 'field-editor-changes-popover' }"
  position="bottom"
  title="Modification"
  [showCloseButton]="true"
  [closeOnOutsideClick]="true"
>
  <div *dxTemplate="let model of 'content'">
    <dx-form
      id="fieldCropForm"
      [formData]="fieldCrop"
      [showValidationSummary]="true"
      (onFieldDataChanged)="addFormChange($event)"
    >
      <dxi-item dataField="name">
        <dxo-label text="Nom"></dxo-label>
        <dxi-validation-rule
          type="required"
          message="Le nom est obligatoire"
        ></dxi-validation-rule>
        <dxi-validation-rule
          type="stringLength"
          [min]="3"
          [max]="100"
        ></dxi-validation-rule>
      </dxi-item>

      <dxi-item dataField="crop_id">
        <dxo-label text="Culture"></dxo-label>
        <div *dxTemplate>
          <app-crop-selector
            (valueChange)="cropChange($event)"
            [value]="fieldCrop?.crop_id"
            [showAddBtn]="true"
            [items]="items"
          ></app-crop-selector>
        </div>
      </dxi-item>

      <dxi-item itemType="group" colCount="2">
        <dxi-item dataField="color" editorType="dxColorBox">
          <dxo-label text="Couleur"></dxo-label>
          <dxi-validation-rule type="required"></dxi-validation-rule>
        </dxi-item>

        <dxi-item dataField="campaign_id">
          <dxo-label text="Campagne"></dxo-label>
          <div *dxTemplate>
            <app-campaign-selector
              (valueChange)="campaignChange($event)"
              [value]="fieldCrop?.campaign_id"
            ></app-campaign-selector>
          </div>
          <dxi-validation-rule type="required"></dxi-validation-rule>
        </dxi-item>
      </dxi-item>

      <dxi-item
        itemType="group"
        [items]="fieldCrop?.crop?.custom_fields"
        colCount="2"
      ></dxi-item>

      <dxi-item itemType="group" colCount="2">
        <dxi-item dataField="started_at" editorType="dxDateBox"></dxi-item>
        <dxi-item
          dataField="estimated_end_at"
          editorType="dxDateBox"
        ></dxi-item>
      </dxi-item>

      <dxi-item dataField="is_irrigated" editorType="dxSwitch">
        <dxo-label text="Irriguée?"></dxo-label>
      </dxi-item>
      <dxi-item
        itemType="button"
        horizontalAlignment="right"
        [buttonOptions]="formSaveBtnOptions"
      >
      </dxi-item>
    </dx-form>
  </div>
</dx-popover>

<dx-popup
  class="field-editor-crops-popup"
  width="60%"
  [height]="550"
  [showTitle]="true"
  [(visible)]="cropsGridVisible"
  [elementAttr]="{ class: 'field-editor-crops-popup' }"
  title="Cultures"
  [showCloseButton]="true"
>
  <div *dxTemplate="let model of 'content'">
    <app-crops-grid
      [height]="500"
      (itemsChange)="corpsItems = $event"
    ></app-crops-grid>
  </div>
</dx-popup>

<dx-load-panel
  [deferRendering]="false"
  shadingColor="rgba(0,0,0,0.1)"
  [position]="{ of: '#fieldCropToolbar' }"
  [(visible)]="loadingVisible"
  [showIndicator]="false"
  [showPane]="false"
  [shading]="true"
  [closeOnOutsideClick]="false"
>
</dx-load-panel>
